import { NextPageContext } from 'next';
import Error, { ErrorProps } from 'next/error';
import React from 'react';

import ErrorPageComponent from '@/components/route/error/ErrorPage/ErrorPage';
import { getIntl } from '@/utility/i18n';
import { logger } from '@/utility/logger';

type StatusCode = ErrorProps['statusCode'];

class ErrorPage extends Error {
  static getInitialProps = ({ req, res, err }: NextPageContext) => {
    const statusCode: StatusCode = res?.statusCode ?? err?.statusCode ?? 418;

    logger.captureExceptionWithDatadog(err, {
      url: req?.url ?? '',
      statusCode: String(statusCode),
    });

    return { statusCode };
  };

  render() {
    const { statusCode } = this.props;
    const message = statusCodeMessage(statusCode);

    return <ErrorPageComponent statusCode={statusCode} message={message} />;
  }
}

export default ErrorPage;

const statusCodeMessage = (statusCode: StatusCode) => {
  const intl = getIntl();

  if (statusCode === 429) {
    return intl.formatMessage({
      defaultMessage: "You're doing that too many times, please try again shortly.",
      id: 'i9T/yB',
      description: 'This error message is for users who are hitting our page too many times',
    });
  }

  if (statusCode >= 500) {
    return intl.formatMessage({
      defaultMessage: `It looks like we're having some issues. Please try again shortly.`,
      id: 'hcZJ/o',
    });
  }

  return intl.formatMessage({
    defaultMessage: "Looks like you're lost.",
    id: 'bDZn2r',
  });
};
